export default {
  Unknown: 'نتیجه عملیات نامشخص است',
  Success: 'عملیات موفقیت آمیز بود',
  Failed: 'عملیات ناموفق بود',
  UserExist: ' کاربر با این مشخصات وجود دارد، در صورت نیاز رمز عبور خود را بازیابی کنید',
  InvalidUsername: 'نام کاربری معتبر نیست',
  UserIsLockedOut: 'تعداد تلاشهای نا موفق شما بیش از حد مجاز بوده است اکانت شما برای مدت 5 دقیقه مسدود گردیده است.',
  UserRegisterationFailed: 'ثبت نام کاربر انجام نشد',
  InvalidUsernameOrPassword: 'نام کاربری یا رمز عبور معتبر نمی باشد',
  UserNotFound: 'کاربری با این مشخصات پیدا نشد',
  RoleNotFound: 'نقش موردنظر پیدا نشد',
  QuestionNotFound: 'سوال موردنظر وجود ندارد',
  AnswerNotFound: 'پاسخ معتبر نیست',
  NewPasswordAndConfirmNotEqual: 'تایید رمز عبور با رمز عبور یکسان نیست',
  MaxConfirmationCodeTryExceeded: 'حداکثر تعداد استفاده از این کد تایید به سر رسیده است!',
  InvalidConfirmationCode: 'کد تایید وارد شده معتبر نیست',
  PasswordNotFound: 'رمز عبوری برای شما تعریف نشده است',
  PasswordExist: 'رمز عبور قبلا تعریف شده است',
  oldPasswordMismatch: 'رمز عبور قبلی اشتباه است',
  UserInfoIsNotCompleted: 'اطلاعات کاربر ناقص است',
  WrongPassword: 'پسورد قدیمی صحیح نیست',
  InvalidDocumentKey: 'کلید فایل معتبر نیست',
  InvalidDocumentSize: 'سایز فایل معتبر نیست',
  InvalidDocumentType: 'فرمت فایل معتبر نیست',
  NationalIdExist: 'کد ملی تکراری است',
  UserNotRegisteredInRayanFund: 'کاربری با این کدملی در صندوق ثبت نشده است',
  Continue2FA: 'کد تایید را وارد کنید',
  InvalidRefreshToken:'توکن شما منقضی شده است',
  InvalidCaptcha: 'اعداد تصویر وارد شده صحیح نیست',
  NationalIdNotFoundInSejam: 'کد ملی وارد شده در سامانه سجام یافت نشد',
  SejamTooManyRequests: 'تعداد درخواستهای شما بیش از اندازه مجاز است',
  InvalidSejamOtp: 'کد وارد شده اشتباه است',
  AmountIsTooSmall: 'حداقل مقدار ورودی رعایت نشده است',
  ParsianBankGatewayFailure: 'خطا در اتصال به درگاه مورد نظر',
  UserDoesNotHasAssetInFund: 'شما در این صندوق داراییی ندارید',
  TooLarge: 'حجم فایل انتخابی باید کمتر از 1 مگابایت باشد',
  SejamOtpNotFound: 'کد تائید قبلا به شماره شما ارسال شده است، لطفا مجددا آن را وارد نمائید.',
  NumberOfWithdrawUnitsIsNotValid: 'موجودي مشتري نبايد كمتر از حداقل تعداد واحد سرمايه گذاري شود',
  NumberOfDepositUnitsIsNotValid: 'حداقل مبلغ مجاز رعایت نشده است',
  SejamError:"برای ثبت نام در سامانه کوروش اینوست,احراز هویت در سامانه سجام الزامی است"
}
